import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useAuth } from './AuthContext';
import { websocketService } from '../services/websocketService';

interface WebSocketContextValue {
    connected: boolean;
    onCitaEvent: (callback: (data: any) => void) => () => void;
}

const WebSocketContext = createContext<WebSocketContextValue | null>(null);

export const WebSocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [connected, setConnected] = useState(websocketService.getConnected());

    const {user, isAuthenticated} = useAuth();
    const userId = user?.id;
    useEffect(() => {
        if (!isAuthenticated || !userId) return;
        websocketService.connect();
        const unsub = websocketService.onConnectionStatus(setConnected);
        return () => {
            unsub();
            websocketService.disconnect();
        };
    }, [isAuthenticated, userId]);

    const onCitaEvent = useCallback((callback: (data: any) => void) => {
        return websocketService.on('cita_actualizada', callback);
    }, []);

    return (
        <WebSocketContext.Provider value={{ connected, onCitaEvent }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = () => {
    const ctx = useContext(WebSocketContext);
    if (!ctx) throw new Error('useWebSocket must be used within WebSocketProvider');
    return ctx;
};
